import React from 'react';
import Input from 'components/project/ClerkScreen/shared/Input';
import PropTypes from 'prop-types';
import { formatCommas } from 'components/project/ClerkScreen/shared/utils/common';
import { Container, InputButtonGroup, Label } from './Styles';

export const StartingBidAmount = ({
  buttonDisabled,
  buttonIcon,
  buttonTabIndex,
  inputDisabled,
  inputRef,
  inputTabIndex,
  labelText,
  maxLength,
  minStartPrice,
  onChange,
  onClick,
  onFocus,
  onKeyPress,
  onKeyUp,
  placeholderText,
  testId,
  value,
}) => {
  const minStartPriceLabel = minStartPrice && minStartPrice > 0
    ? ` (MIN AMT: $${formatCommas(minStartPrice)})`
    : '';

  return (
    <Container>
      <Label>
        {labelText}
        <span>{minStartPriceLabel}</span>
      </Label>
      <InputButtonGroup>
        <Input
          autoComplete="off"
          disabled={inputDisabled}
          maxLength={maxLength}
          onChange={onChange}
          onFocus={onFocus}
          onKeyPress={onKeyPress}
          onKeyUp={onKeyUp}
          placeholderText={placeholderText}
          ref={inputRef}
          tabIndex={inputTabIndex}
          testId={testId}
          value={value}
        />
        <button
          data-testid="starting-bid-amt-btn"
          disabled={buttonDisabled}
          onClick={onClick}
          tabIndex={buttonTabIndex}
          type="button"
        >
          <i className={`fa ${buttonIcon}`} aria-hidden="true" />
        </button>
      </InputButtonGroup>
    </Container>
  );
};

StartingBidAmount.propTypes = {
  buttonDisabled: PropTypes.bool.isRequired,
  buttonIcon: PropTypes.string.isRequired,
  buttonTabIndex: PropTypes.number,
  inputDisabled: PropTypes.bool.isRequired,
  inputRef: PropTypes.object,
  inputTabIndex: PropTypes.number.isRequired,
  labelText: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  minStartPrice: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onKeyUp: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
  testId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

StartingBidAmount.defaultProps = {
  buttonTabIndex: -1,
  inputRef: null,
  labelText: '',
  minStartPrice: 0,
  placeholderText: '',
  value: '',
};

export default StartingBidAmount;
